import type { ISelectionContext } from './ISelectionContext'

export default class CheckBoxSelectionContext implements ISelectionContext {
  constructor(public selectedColumn: number) {}
}
